import React from 'react';

export default function Content() {
  return (
    <div>
      <h1 className="h4 mb-3">Content Management</h1>
      <p className="text-muted">Manage content here.</p>
    </div>
  );
}
